export default __webpack_public_path__ + "static/media/business-leadership-pathway.24b6e759.svg";